module.exports = __webpack_public_path__ + "static/media/banner-photo526@2x.8ab047c6.jpg";